var map = {
	"./black-line.png": "Rl2o",
	"./game-head-cjxxl.png": "NIpT",
	"./game-head-dcpxdcg.png": "ujSe",
	"./game-head-main.png": "u0wQ",
	"./game-head-tlxxl.png": "h2PJ",
	"./game-head-yyhyddp.png": "FEmD",
	"./game-level0.png": "AiZ3",
	"./game-level1.png": "nT0v",
	"./game-level2.png": "hYX8",
	"./game-level3.png": "dpyT",
	"./game-series-1-1.png": "khvv",
	"./game-series-128.png": "BEAU",
	"./game-series-168.png": "8ArK",
	"./game-type-cjxxl.png": "sElN",
	"./game-type-dcpxdcg.png": "Q0eG",
	"./game-type-tlxxl.png": "9tao",
	"./game-type-yyhyddp.png": "s8Ee",
	"./home.png": "KgW8",
	"./person.png": "cKl6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xtbV";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/game ^\.\/.*\.png$
// module id = xtbV
// module chunks = 1